module.exports = __webpack_public_path__ + "static/media/NICE_Step2a_Image18.28b5e7fb.jpg";